import React from 'react';
import {
  HomeIcon,
  ShoppingBagIcon,
  PackageIcon,
  UsersIcon,
  TagIcon,
  ChartIcon,
  ShoppingCartIcon,
  UserIcon,
  SettingsIcon,
  MapPinIcon,
  ClockIcon,
  HeartIcon,
  InboxIcon,
  RefreshIcon,
  HomeModernIcon,
  ImageIcon,
} from '../components/icons/Icons';

export const navigationConfig = {
  customer: [
    { path: '/dashboard', label: 'Dashboard', icon: <HomeIcon size={20} /> },
    { path: '/cart', label: 'Cart', icon: <ShoppingCartIcon size={20} /> },
    { path: '/wishlist', label: 'Wishlist', icon: <HeartIcon size={20} /> },
    { path: '/following', label: 'Following', icon: <UsersIcon size={20} /> },
    { path: '/orders', label: 'My Orders', icon: <PackageIcon size={20} /> },
    { path: '/addresses', label: 'Addresses', icon: <MapPinIcon size={20} /> },
    { path: '/profile', label: 'Profile', icon: <UserIcon size={20} /> },
    { path: '/settings', label: 'Settings', icon: <SettingsIcon size={20} /> },
  ],

  seller: [
    { path: '/seller/dashboard',    label: 'Dashboard',    icon: <ChartIcon size={20} /> },
    { path: '/seller/products',     label: 'Products',     icon: <PackageIcon size={20} /> },
    { path: '/seller/barter',       label: 'Barter',       icon: <RefreshIcon size={20} /> },
    { path: '/seller/rentals',      label: 'Rentals',      icon: <HomeModernIcon size={20} /> },
    { path: '/seller/orders',       label: 'Orders',       icon: <ShoppingBagIcon size={20} /> },
    { path: '/seller/subscription', label: 'Subscription', icon: <TagIcon size={20} /> },
    { path: '/seller/followers',    label: 'Followers',    icon: <UsersIcon size={20} /> },
    { path: '/seller/profile',      label: 'Profile',      icon: <UserIcon size={20} /> },
    { path: '/seller/settings',     label: 'Settings',     icon: <SettingsIcon size={20} /> },
  ],

  admin: [
    { path: '/admin/dashboard', label: 'Dashboard', icon: <HomeIcon size={20} /> },
    { path: '/admin/categories', label: 'Categories', icon: <TagIcon size={20} /> },
    { path: '/admin/products', label: 'Products', icon: <PackageIcon size={20} /> },
    { path: '/admin/orders', label: 'Orders', icon: <ShoppingBagIcon size={20} /> },
    { path: '/admin/refunds', label: 'Refunds', icon: <RefreshIcon size={20} /> },
    { path: '/admin/contact-messages', label: 'Contact Messages', icon: <InboxIcon size={20} /> },
    { path: '/admin/ads', label: 'Ad & Giveaways', icon: <ImageIcon size={20} /> },
    { path: '/admin/sellers/pending', label: 'Pending Sellers', icon: <ClockIcon size={20} /> },
    { path: '/admin/sellers/all', label: 'All Sellers', icon: <UsersIcon size={20} /> },
    { path: '/admin/subscriptions', label: 'Subscriptions', icon: <ChartIcon size={20} /> },
    { path: '/admin/profile', label: 'Profile', icon: <UserIcon size={20} /> },
    { path: '/admin/settings', label: 'Settings', icon: <SettingsIcon size={20} /> },
  ],
};